import { gql } from "@apollo/client";

export const Client = gql`
query da_activeclients {
    aatmsv4_clients(order_by: {clientname: asc}, where: {active: {_eq: true}}) {
      clientname
      clientsid
      department
      headerrh1
      headerrh2
      headerrh3
      logo
    }
  }
`
export const Fleets = gql`
query da_activefleets(
    $id: uuid
) {
    aatmsv4_fleets(order_by: {aircraft: asc}, where: {clientsid: {_eq: $id}}) {
      aircraft
      fleetsid
    }
  }
`
export const subcatagory = gql`
query da_subcategories {
    aatmsv4_subcategory {
      subcategoryid
    }
  }
`
export const Publish_Ground_Form = gql`
mutation da_PublishGroundForm1(
    $clientsid: uuid
    $clientsname: String
    $fleetsid: uuid
    $groundformname: String
    $minutes: Int
    $regulatoryinfo: String
    $remarks: Boolean
    $result: Boolean
    $subcategory: aatmsv4_subcategory_enum
    $validity: Int
) {
    insert_aatmsv4_groundforms(objects: {clientsid: $clientsid, clientsname: $clientsname, fleetsid: $fleetsid, groundformname: $groundformname, minutes: $minutes, regulatoryinfo: $regulatoryinfo, remarks: $remarks, result: $result, subcategory: $subcategory, validity: $validity, category: Ground, blankform: "https://homepages.cae.wisc.edu/~ece533/images/tulips.png"}) {
      returning {fleetsid
        clientsid
        clientsname
        groundformid
        groundformname
        category
        subcategory
        minutes
        remarks
        result
        regulatoryinfo
        fleetsid
        validity
        blankform
      }   }  }
`